import { render, staticRenderFns } from "./IndividualMatterGradesReport.vue?vue&type=template&id=ad05b224&scoped=true"
import script from "./IndividualMatterGradesReport.vue?vue&type=script&lang=js"
export * from "./IndividualMatterGradesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad05b224",
  null
  
)

export default component.exports